import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const LinkedinLogsConversationWrapper = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding-block: 8px;
  .linkedin-logs-message {
    display: flex;
    align-items: flex-start;
    width: 100%;
    gap: 16px;
    padding-right: 8px;
    margin-block: 12px;
    .text-container-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      .single-row {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
      }
    }
  }
  .date-component {
    margin-top: 8px;
    margin-bottom: 4px;
  }
  .day-separator {
    width: 100%;
    border-bottom: 1px solid ${colors.grey444};
  }
  //Hide first day-separator
  .day-separator:first-of-type {
    display: none;
  }
`;
